
function gtagClick(log,lan) {
	/* eslint-disable-next-line */
	gtag('event', 'click', {
		// xxx改成页面代号（前端自定）
		'event_category': 'twitch_drop-' + log + "-" + lan,
	});
}
// 上报埋点
export const gaReport = {
	//进入 登录 召唤 分享 答题
	bind(lan){
		gtagClick("bind",lan);
	},
	share(lan){
		gtagClick("share",lan);
	},	
	event(lan){
		gtagClick("event",lan);
	},
	login(lan){
		gtagClick("login",lan);
	}
}
